import React, { useEffect, useState } from "react";
import "./pages-css/IsecNavbar2.css";
import "./pages-css/UpdatePassword.css";
import { useAuth } from "../../Context/UserContext";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import { url } from "../../constants/url";
import Breadcrumb from "../Modal/Breadcrumb";
import UserProfile from "../Modal/UserProfile";
import Notification from "../Modal/Notification";


const IsecNavbar2 = (props) => {

  const { singleProjectData, projectName, projectid } = props;
  const [confirmLogout, setConfirmLogout] = useState(false);

  const {
    user,
    logout,
    fetchNotification,
    notificationData,
    notificationCount,
    setIsSidebarCollapsed,
  } = useAuth();

  const [openNotification, setOpenNotification] = useState(false);
  const [bounce, setBounce] = useState(false);
  const [prevNotificationCount, setPrevNotificationCount] = useState(notificationCount);
  const [hoverOnEnvelope, setHoverOnEnvelope] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [closingDropdown, setClosingDropdown] = useState(false);

  const [openPassword, setOpenPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [openUserProfile, setOpenUserProfile] = useState(false);

  const specialChars = /[!@#$%^&*(),.?":{}|<>]/;

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordView, setPasswordView] = useState(false);

  const navigate = useNavigate();

  const firstLetter = user ? user?.charAt(0).toUpperCase() : "";

  const updateSucess = () => {
    toast.success("Password successfully updated...", {
      position: "top-right",
      autoClose: 2500,
      pauseOnHover: false,
    });
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const togglePasswordView = () => {
    setPasswordView(!passwordView);
  };

  const updatePasswordHandler = async (e) => {
    e.preventDefault();
    if (oldPassword === "") {
      setOldPasswordError("Enter your old password!");
      return;
    } else if (newPassword === "") {
      setNewPasswordError("Enter your new password!");
    } else if (confirmPassword === "") {
      setConfirmPasswordError("Confirm your password!");
    } else if (oldPassword === newPassword) {
      setNewPasswordError("Old password and New password should not be same!");
    } else if (newPassword !== confirmPassword) {
      setConfirmPassword("");
      setConfirmPasswordError("Password does not match!");
      return;
    } else if (newPassword.length < 8) {
      setNewPasswordError("Password should be a minimum of 8 character");
      return;
    } else if (!specialChars.test(newPassword)) {
      setNewPasswordError(
        "Password should include at least one special character"
      );
      return;
    } else if (!/[A-Z]/.test(newPassword)) {
      setNewPasswordError(
        "Password should include at least one alphabet character"
      );
      return;
    } else {
      try {
        const response = await fetch(`${url}/updatepassword`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            oldPassword,
            newPassword,
            confirmPassword,
          }),
        });

        if (response.status === 403) {
          toast.error("Old password is incorrect...", {
            position: "top-center",
            autoClose: 2500,
            pauseOnHover: false,
          });
        }
        if (response.status === 200) {
          updateSucess();
          logout();
          setOldPassword("");
          setNewPassword("");
          setConfirmPassword("");
          setTimeout(() => {
            logout();
          }, 2000);
          return;
        }
        if (response.status === 440) {
          logout();
          toast.error("User logout due to inactivity", {
            position: "top-right",
            autoClose: 2500,
            pauseOnHover: false,
          });
          return;
        }
      } catch (error) {
        console.log(error);
        toast.error("Internal Server Error", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      setConfirmLogout(false);
    } catch (error) {
      alert(error.message);
    }
  };

  const handleLogoutPage = () => {
    setConfirmLogout(true);
  };

  const handleCancel = () => {
    setConfirmLogout(false);
  };

  const handleNotification = () => {
    setOpenNotification(true);
    fetchNotification();
  };

  const toggleDropdown = () => {
    setOpenUserProfile(!openUserProfile)
  };


  useEffect(() => {
    fetchNotification();

    if (notificationCount > prevNotificationCount) {
      setBounce(true);
      const timeout = setTimeout(() => setBounce(false), 600);
      return () => clearTimeout(timeout);
    }
    setPrevNotificationCount(notificationCount);
  }, [notificationCount, prevNotificationCount]);

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) return "Good Morning";
    if (hour >= 12 && hour < 17) return "Good Afternoon";
    if (hour >= 17 && hour < 21) return "Good Evening";
    return "Good Night";
  };

  return (
    <div className="isecNavbar2_container">
      <div className="isecNavbar2_menu_container">
        <div className="isec_navbar2_menu">

          <div className="isec_navbar2_menu_btn_container" onMouseEnter={() => setIsSidebarCollapsed(true)} onMouseLeave={() => setIsSidebarCollapsed(false)}>
            <button className="isec_navbar2_btn">
              <Icon icon="prime:bars" width="22" height="22" color="#fff" />
            </button>
          </div>

          <div className="isec_navbar2_menu_user_name">

            {window.location.pathname === "/isecurion_dash" && (
              <Breadcrumb items={[{ label: "Dashboard" }]} />
            )}
            {window.location.pathname === "/isecurion/generatereport" && (
              <Breadcrumb items={[{ label: "Report Generation" }]} />
            )}
            {window.location.pathname === "/isecurion/messenger" && (
              <Breadcrumb items={[{ label: "Chatbox" }]} />
            )}

            {window.location.pathname === "/isecurion/projects/all" && (
              <Breadcrumb items={[{ label: "Projects" }]} />
            )}
            {window.location.pathname === "/isecurion/adduser" && (
              <Breadcrumb items={[{ label: "Manage User" }]} />
            )}
            {window.location.pathname.startsWith("/projects/status/") && (
              singleProjectData && (
                <Breadcrumb
                  items={[
                    { label: "Project", href: "/isecurion/projects/all" },
                    { label: singleProjectData.projectName },
                  ]}
                />
              )
            )}
            {window.location.pathname.startsWith("/isecurion_dash/status/") && (
              <Breadcrumb
                items={[

                  { label: projectName, href: `/projects/status/${projectid}` },
                  { label: 'Add vulnerability' },
                ]}
              />
            )}
            {window.location.pathname.startsWith("/isecurion/viewvulnerabilities") && (
              <Breadcrumb items={[{
                label: "<- Back", href: `/projects/status/${projectid}`
              }
              ]} />
            )}

          </div>
        </div>
        <div className="isec_navbar2_user_profile">
          <button onClick={handleNotification} className={
            notificationCount > 0 ? "navbar_content_notify" : "navbar_content_empty"
          }>
            <Icon icon="bitcoin-icons:bell-filled" width="26" height="26" />
            {notificationCount > 0 && (
              <span className='notification_badge_navbar2'>
                {notificationCount > 9 ? '9+' : notificationCount}
              </span>
            )}
          </button>

          <div className='navbar2_isec' onClick={toggleDropdown}>
            <h4>{firstLetter}</h4>
          </div>

        </div>
      </div>

      {openUserProfile && (
        <UserProfile setOpenUserProfile={setOpenUserProfile} firstletter={firstLetter} toggleDropdown={toggleDropdown} />
      )}

      {openNotification && (
        <Notification
          setOpenNotification={setOpenNotification}
          notificationData={notificationData}
          fetchNotification={fetchNotification}
          hoverOnEnvelope={hoverOnEnvelope}
          setHoverOnEnvelope={setHoverOnEnvelope}
        />
      )}

    </div>
  );
};

export default IsecNavbar2;